// extracted by mini-css-extract-plugin
export var logo = "NavLogo-module--logo--89f24";
export var showText = "NavLogo-module--showText--73771";
export var spinner = "NavLogo-module--spinner--2df3a";
export var text = "NavLogo-module--text--5dda0";